import React, { MutableRefObject, useRef } from 'react';

export default function useHorizontalScroll<T extends HTMLElement>(): {
  scrollableRef: MutableRefObject<T | null>;
  handleMouseDown: (e: React.MouseEvent<T>) => void;
} {
  const scrollableRef = useRef<T | null>(null);

  function handleMouseDown(e: React.MouseEvent<T>) {
    e.preventDefault();
    const startX = e.pageX - (scrollableRef.current as HTMLElement).offsetLeft;
    const scrollLeft = (scrollableRef.current as HTMLElement).scrollLeft;

    function handleMouseMove(e: MouseEvent) {
      e.preventDefault();
      const x = e.pageX - startX;
      (scrollableRef.current as HTMLElement).scrollLeft = scrollLeft - x;
    }

    function handleMouseUp() {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    }

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  }

  return { scrollableRef, handleMouseDown };
}
